export default "__VITE_ASSET__BjeY6yjQ__"